import { render } from "./PanelFacturacion.vue?vue&type=template&id=6a83b90e"
import script from "./PanelFacturacion.vue?vue&type=script&lang=js"
export * from "./PanelFacturacion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__